import React from "react";
import ErrorField from "./error";
import { TextField } from "components/support";
import { observer } from "mobx-react";

const NameField = ({ errors, row, onChange }) => {
  const { name } = row;
  const foundErrors = errors.find(v => v.name === row.name);
  const hasErrors =
    foundErrors && !!foundErrors.errors && !!foundErrors.errors.name;

  return (
    <div>
      <TextField
        value={name}
        onChange={(_, value) => onChange(value)}
        fullWidth
      />
      {hasErrors && <ErrorField error={foundErrors.errors.name} />}
    </div>
  );
};

export default observer(NameField);



// WEBPACK FOOTER //
// ./src/components/app/registration/product/batch/fields/name.js